export default "__VITE_ASSET__CetY4HbK__"